// Welded to the @custom-media widths in styles/tokens/tokens.css by spec/integration/frontend_conventions_spec.rb.
export const BREAKPOINTS = {
  narrowest: '(max-width: 22.5rem)',
  narrow: '(max-width: 40rem)',
  medium: '(max-width: 56rem)',
  wide: '(max-width: 64rem)',
  compactRoom: '(max-width: 40rem), (max-height: 30rem)',
  widest: '(max-width: 85rem)',
} as const

export type Breakpoint = keyof typeof BREAKPOINTS
